module.exports = __webpack_public_path__ + "static/media/mai2.300b5713.jpg";